import {BannerDef} from '../../components/banner/banner.component';

export const Banners: {
    energySaver: BannerDef,
    meterConnecting: BannerDef,
    meterConnectingTutorial: BannerDef
} = {
    energySaver: {
        type: 'alert',
        prio: 1,
        main: 'Energiesparmodus:',
        sub: 'Datenübertragung nur nach größeren Veränderungen (>50W).',
        route: [
            'einstellungen',
            'energy-saver'
        ]
    },
    meterConnecting: {
        type: 'info',
        prio: 2,
        main: 'Zähler wird verbunden...',
        sub: '',
        route: [
            '/registrieren'
        ],
        params: {
            jumpToMeterstate: true
        }
    },
    meterConnectingTutorial: {
        type: 'info',
        prio: 2,
        main: 'Zähler wird verbunden...',
        sub: '',
        route: [
            '/registrieren'
        ],
        params: {
            jumpToTutorial: true
        }
    }
};
